import { render, staticRenderFns } from "./PorletCalendario.vue?vue&type=template&id=1f4c488c"
import script from "./PorletCalendario.vue?vue&type=script&lang=js"
export * from "./PorletCalendario.vue?vue&type=script&lang=js"
import style0 from "./PorletCalendario.vue?vue&type=style&index=0&id=1f4c488c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports